import React, {useState} from "react"
import {Tab, Grid, Stack} from "@mui/material";
import {formatTime, getSellerNames} from "@/helper/method";
import Box from "@mui/material/Box";
import {GridItem} from "@/widget/GridItem/GridItem";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {GridColDef,} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ProjectVO, useQueryProject} from "@/service/project.s";
import {CopyrightPO, PatentPO, TrademarkPO} from "@/model/product";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {useQueryPatentPage} from "@/service/patent.s";
import {useQueryTrademarkPage} from "@/service/trademark.s";
import {useQueryCopyrightPage} from "@/service/copyright.s";
import {useDrawerModal} from "@/store/global.c";
import {TaskTable} from "@/widget/CommonDetail/TaskTable";
import {SiteAccountTable} from "@/widget/SiteAccount/SiteAccountTable";
import Chip from "@mui/material/Chip";
import {roleAlias, writeStatus} from "@/helper/constant";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import {useAuthInfo} from "@/store/account.c";
import {ContactDetail} from "@/widget/CommonDetail/PaybackDetail";

export const ViewProject = () => {
    const {id} = useDrawerModal()
    const {data: projectData, isLoading: projectLoading} = useQueryProject({id: id!})
    const [tab, setTab] = useState<number>(1)
    const {
        mutate: patentPageMutate,
        data: patentPageData,
        isPending: patentPagePending,
    } = useQueryPatentPage(0)
    const project = projectData?.data || {} as ProjectVO
    const {
        mutate: trademarkPageMutate,
        data: trademarkPageData,
        isPending: trademarkPagePending,
    } = useQueryTrademarkPage(0)
    const {
        mutate: copyrightPageMutate,
        data: copyrightPageData,
        isPending: copyrightPagePending,
    } = useQueryCopyrightPage(0)
    const {role: {roleAlias: roleName}} = useAuthInfo()
    const patentColumns: GridColDef<PatentPO>[] = [
        {
            field: "patentName", headerName: "专利名称", flex: 0.3,
            valueFormatter: value => value || "待定"
        },
        {
            field: "patentNo",
            headerName: "专利号/申请号", flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "category",
            headerName: "申请类型",
            flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "writer",
            headerName: "撰稿人",
            flex: 0.2,
            valueFormatter: value => value || "-"
        },

    ];

    const trademarkColumns: GridColDef<TrademarkPO>[] = [
        {field: "trademarkName", headerName: "商标名称", flex: 0.4,},
        {
            field: "trademarkStatus",
            headerName: "商标状态", flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "applyNo",
            headerName: "申请号",
            flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "writer",
            headerName: "撰稿人",
            flex: 0.2,
            valueFormatter: value => value || "-"
        },
    ];

    const copyrightColumns: GridColDef<CopyrightPO>[] = [
        {field: "copyrightName", headerName: "版权名称", flex: 0.4, valueFormatter: value => value || "-"},
        {
            field: "copyrightStatus",
            headerName: "版权状态", flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "category",
            headerName: "版权类型",
            flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "writer",
            headerName: "撰稿人",
            flex: 0.2,
            valueFormatter: value => value || "-"
        },
    ];

    return <>
        <ResultWrapper isLoading={projectLoading} isEmpty={isEmpty(project)}>
            <Stack direction={'column'} gap={2}>
                <Grid
                    spacing={3}
                    container>
                    <GridItem title={'政策项目名称'} content={project?.category}/>
                    <GridItem title={'申报状态'} content={project?.projectStatus}/>
                    <GridItem title={'提报日期'} content={formatTime("D", project?.applyDate)}/>
                    <GridItem title={'公示日期'} content={formatTime("D", project?.publicityDate)}/>
                    <GridItem title={'获批年度'}
                              content={<Chip color={'error'} size={'small'} label={formatTime("Y", project?.approvedYear)}/>}/>
                    <GridItem title={'补贴金额'}
                              content={project?.subsidyAmount}/>
                    <GridItem title={'资质有效截止日期'} content={formatTime("D", project?.validDate)}/>
                    <GridItem title={'申报级别'}
                              content={project?.level}/>
                    <GridItem title={'受理部门'}
                              content={project?.section}/>
                    <GridItem title={'官方起止日期'}
                              content={isEmpty(project?.startDate) && isEmpty(project?.endDate) ? "-" : `${formatTime("D", project?.startDate)}至${formatTime("D", project?.startDate)}`}/>
                </Grid>
                <TabContext value={tab}>
                    <Stack direction="column" spacing={2}>
                        <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                            <TabList variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                                <Tab label="详细信息" value={1}/>
                                {/*<Tab label="实施节点" value={4}/>*/}
                                <Tab label="网报账号" value={5}/>
                                <Tab label="合同" value={2}/>
                                <Tab label="对接人" value={8}/>
                                <Tab label="回款" value={3}/>
                                <Tab label="知识产权" value={6}/>
                            </TabList>
                        </Box>
                        <TabPanel value={1} sx={{mt: 1, p: 0}}>
                            <Stack direction={'column'} gap={2}>
                                <Grid
                                    spacing={3}
                                    container>
                                    <GridItem title={'客户名称'} content={project?.customerName}/>
                                    <GridItem title={'联系人'} content={project?.contact}/>
                                    <GridItem title={'联系电话'} content={project?.contact}/>
                                    <GridItem title={'业务人员'} content={getSellerNames(project?.creator, project?.seller)}/>
                                    <GridItem title={'价格'} content={project?.price}/>
                                    <GridItem title={'分配人'} content={project?.assigner}/>
                                    <GridItem title={'分配时间'} content={formatTime("D", project?.assignTime)}/>
                                    <GridItem title={'撰稿人'} content={project?.writer}/>
                                    <GridItem title={'接收时间'} content={formatTime("D", project?.receiveTime)}/>
                                    <GridItem title={'撰写状态'} content={project?.writeStatus}/>
                                    <GridItem title={`${writeStatus[project.writeStatusId] || "撰写"}时间`} content={formatTime("D", project?.writeStatusTime)}/>
                                    <GridItem title={'内部期限'} content={formatTime("D", project?.insideDeadline)}/>
                                    <GridItem size={12} minHeight={80} title={'备注'}/>
                                    <GridItem title={'更新时间'} content={formatTime("D", project?.updatedAt)}/>
                                    <GridItem title={'创建时间'} content={formatTime("D", project?.createdAt)}/>
                                </Grid>
                            </Stack>
                        </TabPanel>
                        <TabPanel value={2} sx={{p: 0}}>
                            <ContractDetail data={project?.contract}/>
                        </TabPanel>
                        <TabPanel value={3} sx={{p: 0}}>
                            <PaybackTable enabled={false} data={project?.paybacks}/>
                        </TabPanel>
                        <TabPanel value={4} sx={{p: 0}}>
                            <TaskTable/>
                        </TabPanel>
                        <TabPanel value={5} sx={{p: 0}}>
                            <SiteAccountTable disabled={!(roleName == roleAlias['declarer'])} customerId={project.customerId}/>
                        </TabPanel>
                        <TabPanel value={8} sx={{p: 0}}>
                            <ContactDetail id={project?.contract?.contactId}/>
                        </TabPanel>
                        <TabPanel value={6} sx={{p: 0}}>
                            <Stack gap={2} display={'flex'}>
                                <ProTable<PatentPO> loading={patentPagePending} checkboxSelection={false}
                                                    showToolbar={false}
                                                    onSearch={(params) => patentPageMutate({...params, customerId: project?.customerId})}
                                                    data={patentPageData?.data} pageSize={5}
                                                    autoHeight={false}
                                                    columns={patentColumns} columnHeaderHeight={40}/>
                                <ProTable<TrademarkPO> loading={trademarkPagePending} checkboxSelection={false}
                                                       showToolbar={false}
                                                       onSearch={(params) => trademarkPageMutate({
                                                           ...params,
                                                           customerId: project?.customerId
                                                       })}
                                                       autoHeight={false}
                                                       data={trademarkPageData?.data} pageSize={5}
                                                       columns={trademarkColumns} columnHeaderHeight={40}/>
                                <ProTable<CopyrightPO> loading={copyrightPagePending} checkboxSelection={false}
                                                       showToolbar={false}
                                                       onSearch={(params) => copyrightPageMutate({
                                                           ...params,
                                                           customerId: project?.customerId
                                                       })}
                                                       autoHeight={false}
                                                       data={copyrightPageData?.data} pageSize={5}
                                                       columns={copyrightColumns} columnHeaderHeight={40}/>
                            </Stack>
                        </TabPanel>
                    </Stack>
                </TabContext>
            </Stack>
        </ResultWrapper>
    </>
};


